import i18n from 'i18next';

const gameTransactionTypes = {
    '5 Correct Examples in a Row': 'transactionsHistory.fiveCorrectAnswers',
    '50% Correct in Homework Cycle': 'transactionsHistory.over_50%_correct',
    'Full Homework Completion (Week)': 'transactionsHistory.completedAllHomeworkForWeek',
    'Victory Olympiad': 'transactionsHistory.olympicVictory',
    'Olympiad Participation': 'transactionsHistory.olympicsParticipation',
    Bracelet: 'transactionsHistory.passiveBraceletIncome',
    'Income from Buildings': 'transactionsHistory.passiveBuildingIncome',
    'Cycle Completion Recorded': 'transactionsHistory.cycleCompletionRecorded',
    'Example Difficulty Level': 'transactionsHistory.exampleDifficultyLevel',
};

export const getGameTransactionLabel = transactionType => {
    if (gameTransactionTypes[transactionType]) {
        return i18n.t(gameTransactionTypes[transactionType]);
    }

    const rewardsMatch = transactionType.match(/^Rewards Seq (.+)$/i);
    if (rewardsMatch) {
        return `${i18n.t('transactionsHistory.rewardsSeq')} ${rewardsMatch[1].toUpperCase()}`;
    }

    const constructionMatch = transactionType.match(/^Construction (.+)$/i);
    if (constructionMatch) {
        const buildingName = constructionMatch[1];
        return `${i18n.t('transactionsHistory.construction')} (${buildingName})`;
    }

    return transactionType;
};
